import { cn } from "@/lib/utils/cn";
import { formatMinutesToHours } from "../../components/DashboardHomeView";
import type { CongesDashboardSummary } from "../types";
import { LeaveBalanceCard } from "./LeaveBalanceCard";

interface CongesMetricsRowProps {
  data?: CongesDashboardSummary;
}

export function CongesMetricsRow({ data }: CongesMetricsRowProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 animate-fade-in">
      <LeaveBalanceCard
        title="Congés Payés"
        used={data?.utilisesCongesPayes ?? 0}
        total={data?.totalCongesPayes ?? 25}
        color="info"
        year={data?.anneeCongesPayes}
        className="animate-slide-in-left"
        style={{ animationDelay: "0ms" }}
      />
      <LeaveBalanceCard
        title="RTT"
        used={data?.utilisesRTT ?? 0}
        total={data?.totalRTT ?? 10}
        color="success"
        year={data?.anneeRTT}
        className="animate-slide-in-left"
        style={{ animationDelay: "50ms" }}
      />
      <LeaveBalanceCard
        title="Heures Sup"
        used={data?.utilisesHeuresSup ?? 0}
        total={data?.totalHeuresSup ?? 0}
        color="warning"
        unit="heures"
        formatValue={formatMinutesToHours}
        className="animate-slide-in-left"
        style={{ animationDelay: "100ms" }}
      />
    </div>
  );
}
